import React, { useEffect } from "react";
import { useAuth, hasAuthParams } from "react-oidc-context";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { useSessionstorageState } from "rooks";
import LoginService from "services/loginService";

const useStyles = makeStyles({
  spinner: {
    position: "absolute",
    top: "50%",
    left: "calc(50% + 100px)",
    zIndex: "100",
  },
});

function CallbackPage() {
  const auth = useAuth();
  const history = useHistory();
  const classes = useStyles();
  const [redirectPath, , removeRedirectPath] = useSessionstorageState("redirectPath", "/dashboard");

  useEffect(() => {
    const target = redirectPath || "/dashboard";

    if (!auth.isLoading && auth.isAuthenticated) {
      removeRedirectPath();
      try {
        LoginService.logLogin();
      } catch (err) {}
      history.replace(target);
    } else if (!auth.isLoading && !auth.isAuthenticated && !hasAuthParams()) {
      history.replace(target);
    }
  }, [auth.isLoading, auth.isAuthenticated]);

  return <CircularProgress className={classes.spinner} />;
}

export default CallbackPage;
